class Pagination {
    constructor(container, options = {}) {
        this.container = container
        this.totalPages = options.totalPages || 1
        this.currentPage = options.currentPage || 1
        this.onPageChange = options.onPageChange || (() => {})

        this.init()
    }

    init() {
        this.render()
        this.attachEvents()
    }

    render() {
        const paginationHTML = this.generatePaginationHTML()
        this.container.innerHTML = paginationHTML
    }

    generatePaginationHTML() {
        const total = this.totalPages
        const current = this.currentPage

        if (total <= 1) return ''

        let html = ''

        // Если страниц 6 или меньше - показываем все
        if (total <= 6) {
            for (let i = 1; i <= total; i++) {
                html += this.createPageItem(i, i === current)
            }
            return html
        }

        // Всегда добавляем первую страницу
        html += this.createPageItem(1, current === 1)

        // Определяем, нужно ли первое многоточие
        if (current > 4) {
            html += '<li class="ellipsis">...</li>'
        }

        // Логика для отображения страниц
        if (current <= 4) {
            // Близко к началу: показываем 2,3,4,5
            for (let i = 2; i <= 5 && i < total; i++) {
                html += this.createPageItem(i, i === current)
            }
        } else if (current >= total - 3) {
            // Близко к концу: показываем total-4, total-3, total-2, total-1
            for (let i = Math.max(2, total - 4); i < total; i++) {
                html += this.createPageItem(i, i === current)
            }
        } else {
            // В середине: показываем current-1, current, current+1
            for (let i = current - 1; i <= current + 1; i++) {
                html += this.createPageItem(i, i === current)
            }
        }

        // Определяем, нужно ли второе многоточие
        if (current < total - 3) {
            html += '<li class="ellipsis">...</li>'
        }

        // Добавляем последнюю страницу
        html += this.createPageItem(total, current === total)

        return html
    }

    createPageItem(page, isActive) {
        return `
                    <li class="page-item ${isActive ? 'active' : ''}">
                        <a class="page-link" data-page="${page}">${page}</a>
                    </li>
                `
    }

    attachEvents() {
        this.container.addEventListener('click', (e) => {
            if (e.target.classList.contains('page-link')) {
                e.preventDefault()
                const page = parseInt(e.target.dataset.page)

                if (page && page !== this.currentPage && page >= 1 && page <= this.totalPages) {
                    this.currentPage = page
                    this.render()
                    this.onPageChange(page)
                }
            }
        })
    }

    update(options) {
        if (options.totalPages !== undefined) {
            this.totalPages = options.totalPages
        }
        if (options.currentPage !== undefined) {
            this.currentPage = options.currentPage
        }
        this.render()
    }
}

export default Pagination
